import useCheckoutPresenter from '@Screens/Checkout/presenter';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { Platform, TextStyle } from 'react-native';
import styled from 'styled-components/native';

import OwnableTheme from '../../../../assets/OwnableTheme';
import { PrimaryButton } from '../../../Common/PrimaryButton';
import { Text } from '../../../Common/Text';
import TextInput from '../../../Common/TextInput';
import { useCheckoutContextState } from '../CheckoutContextState';
import { defaultInputProps } from './index';

import { useAuthStore } from '~stores/authentication';
import { useCheckoutStore } from '~stores/checkout';
import { IS_SMALL_SCREEN } from '@Constants/LeftDrawer';
import { buttonLabelStyles } from '../utils';

const StyledContainer = styled.View`
  align-items: center;
  justify-content: flex-start;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
  ${() => Platform.OS !== 'web' && 'flex: 1'}
  margin-bottom: 20px;
`;

const StyledButtons = styled.View`
  display: flex;
  flex-direction: row;
`;

const LoginDetailsStep: FC<object> = () => {
  // noinspection JSUnusedLocalSymbols
  const {
    checkoutLoginEmail,
    setCheckoutLoginEmail,
    checkoutLoginPassword,
    setCheckoutLoginPassword,
    isFeatureAvailableForCheckout,

    // SIDE EFFECT: If this unused assignment (`currentAvailableCheckoutFeatures`) isn't included, re-renders for features don't trigger
    // I have no idea why this fixes the issue of login fields not appearing but it does so ¯\_(ツ)_/¯
    // DO NOT REMOVE THE BELOW ASSIGNMENT, EVEN IF IT IS UNUSED
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    currentAvailableCheckoutFeatures,
  } = useCheckoutStore();

  const {
    handleCancelCheckoutFlow,
    _onUserClickLoginButton,
    orderDetailsVisible,
  } = useCheckoutPresenter();
  const { error } = useAuthStore();
  const [_, setUserHasAttemptedSubmit] = useState<boolean>(false);

  const { loginDetailsVisible, onCancelButton } = useCheckoutContextState();
  useEffect(
    () => () => {
      loginDetailsVisible.set(false);
    },
    []
  );

  if (!isFeatureAvailableForCheckout('ShowLoginFields')) {
    loginDetailsVisible.set(false);
    return null;
  }

  loginDetailsVisible.set(true);

  return (
    <StyledContainer>
      <TextInput
        {...defaultInputProps}
        value={checkoutLoginEmail}
        placeholder='Your email address'
        onChange={(text) => {
          setUserHasAttemptedSubmit(false);
          setCheckoutLoginEmail(text);
        }}
      />

      <TextInput
        {...defaultInputProps}
        value={checkoutLoginPassword}
        placeholder='Your password'
        secureTextEntry
        onChange={(text) => {
          setUserHasAttemptedSubmit(false);
          setCheckoutLoginPassword(text);
        }}
      />

      <Text
        gutterBottom={10}
        color={OwnableTheme.colors.errorRed}
        fontStyleOverride={buttonLabelStyles}
      >
        {error?.message ?? ' '}
      </Text>

      <StyledButtons>
        <PrimaryButton
          text='Submit'
          color='black'
          textColor={OwnableTheme.colors.white}
          fontStyleOverride={buttonLabelStyles}
          onPress={_onUserClickLoginButton}
        />
        <PrimaryButton
          text='Cancel'
          color='white'
          textColor='black'
          borderColor='black'
          fontStyleOverride={buttonLabelStyles}
          onPress={() => {
            orderDetailsVisible.set(false);
            onCancelButton();
            handleCancelCheckoutFlow();
          }}
        />
      </StyledButtons>
    </StyledContainer>
  );
};

export default observer(LoginDetailsStep);
